import React from "react";
import { Table, InputNumber, Form, Space } from "antd";
import get from "lodash/get";

const PartPunchPressSettings = ({ name, partsData, form, config }) => {

  if (!get(partsData, "length")) return null;

  const columns = [
    {
      title: "Part Name",
      dataIndex: "name",
      width: 200,
      render: (_, record) => (
      <p className="inline-block">
          <p className="text-xs break-words">{get(record, "name", "--")}</p>
          {get(record, "item_id") && (
            <p className="text-xs break-words">{get(record, "item_id", "--")}</p>
          )}
        </p>
      ),
    },
    {
      title: "Press Cycle",
      dataIndex: ["meta", "Press Cycle"],
      align:"center",
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "press_cycle"]}
         rules={[
                {
                  required: true,
                  message: "Please input Press Cycle...!",
                },
              ]}
        >
          <InputNumber
            className="w-full"
            placeholder="press_cycle"
            size="small"
            defaultValue={0}
          />
        </Form.Item>
      ),
    },
    {
      title: "Planned Production",
      dataIndex: ["meta", "planned_production_count"],
      align:"center",
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[
            name,
            "parts_full",
            rowIndex,
            "meta",
            "planned_production_count",
          ]}
          rules={[{ required: true, message: "Planned count required" }, { type: "number", min: 1, message: "Planned count should be greater than 1" }]}
        >
          <InputNumber
            className="w-full"
            placeholder="Count"
            size="small"
            defaultValue={0}
            onChange={(value) => {
              form.setFieldValue(
                [
                  "components",
                  name,
                  "parts_full",
                  rowIndex,
                  "meta",
                  "planned_production_count",
                ],
                value
              );
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: "Rejected Count",
      dataIndex: ["meta", "rejected_count"],
      align:"center",
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "rejected_count"]}
        // rules={[{ required: true, message: "Rejected count required" }]}
        >
          <InputNumber
            placeholder="Rejected count"
            className="w-full"
            size="small"
            defaultValue={0}
          />
        </Form.Item>
      ),
    },

    {
      title: "Part Weight (gm)",
      dataIndex: ["meta", "part_weight"],
      align:"center",
      render: (_, __, rowIndex) => (
        <Form.Item
          name={[name, "parts_full", rowIndex, "meta", "part_weight"]}
        // rules={[validatePartWeight(name, rowIndex)]}
        >
          <InputNumber
            className="w-full"
            placeholder="Part weight"
            addonAfter="gm"
            size="small"
            defaultValue={0}
            precision={2}
          />
        </Form.Item>
      ),
    },
      {
      title: "Job / Contratual / Profit Cost",
      dataIndex: ["meta", "costings"],
      minWidth:200,
      render: (_, __, rowIndex) => (
        <Space.Compact>
          <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "job_cost_per_pc"]} label="" >
            <InputNumber placeholder="Job"
              style={{ width: "100%" }} size="small"
              prefix="₹"
              defaultValue={0}
            />
          </Form.Item>

          <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "contractual_cost_per_pc"]} label="">
            <InputNumber placeholder="Contratual"
              style={{ width: "100%" }} size="small"
              prefix="₹"
              defaultValue={0}
            />
          </Form.Item>

          <Form.Item name={[name, "parts_full", rowIndex, 'meta', 'costings', "profit_per_pc"]} label="">
            <InputNumber placeholder="Profit"
              style={{ width: "100%" }} size="small"
              prefix="₹"
              defaultValue={0}
            />
          </Form.Item>
        </Space.Compact>
      ),
    },
       {
          title: "Units / box",
          dataIndex: ["meta", "units_per_box"],
      align:"center",
          render: (_, __, rowIndex) => (
            <Form.Item
              name={[name, "parts_full", rowIndex, "meta", "units_per_box"]}
              rules={[
            {
              required: true,
              message: "Please Enter Units Per Box...!",
            },
            {
              type: "number",
              min: 1,
              message: "Units Per Box must be at least 1",
            },
          ]}
            >
              <InputNumber
                className="w-full"
                placeholder="Units Per Box"
                size="small"
                defaultValue={1}
              />
            </Form.Item>
          ),
        },
  ];

  return (
    <Table
      size="small"
     rowKey={(record) => get(record, "id") || crypto.randomUUID()}
      pagination={false}
      dataSource={partsData}
      columns={columns}
      scroll={{ x: true }}
      bordered
      onHeaderRow={(columns, index) => {
        return {
          className: "text-xs",
        };
      }}
      onRow={() => {
        return {
          className: "text-xs",
        };
      }}
    />
  );
};
export default PartPunchPressSettings;
